export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY hh:mm a';
export const SHORT_DATE_FORMAT = 'MM/DD/YYYY';
export const SHORT_DATE_TIME_FORMAT = 'MM/DD/YY HH:mm';
export const MONTH_DAY_DATE_FORMAT = 'MM/DD';
export const DEFAULT_DATE_TIME_FORMAT = 'hh:mm a';
